import { InputFormGroup } from "@containers/common/input-form-group/input-form-group"
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { AxnuiErrorCodeTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContentError } from "@iddataweb/idw-common-ui/types";
import { ChangeEvent, useState } from "react";

type ThemingErrorPageErrorCodeComponentProps = {
    errorCode: AxnuiErrorCodeTypes;
    isDisabled: boolean;
    axnuiContentError: AXNUIContentError;
    validationError: React.ReactNode;
    onChange: (value: string, key: AxnuiErrorCodeTypes) => void;
    onReset: (key: AxnuiErrorCodeTypes) => void;
    rightAlignedLabelElement?: React.ReactNode;
}

export const ThemingErrorPageErrorCodeComponent = (props: ThemingErrorPageErrorCodeComponentProps) => {
    const [labelWidth] = useState(LabelWidthTypes.EXTRA_SMALL);
    const [layout] = useState(LayoutTypes.COLUMN);
    const { errorCode, axnuiContentError, isDisabled, onChange, onReset, rightAlignedLabelElement, validationError } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value, errorCode);
    }

    const handleReset = () => {
        onReset(errorCode);
    }

    return <>
        <InputFormGroup
            controlId={`theming-error-page-error-type-codes-${errorCode.toLocaleLowerCase()}`}
            automationId={`theming-error-page-error-type-codes-${errorCode.toLocaleLowerCase()}`}
            label={`${errorCode} Message`}
            ariaLabel={`${errorCode} Message`}
            layout={layout}
            labelWidth={labelWidth}
            onChange={handleChange}
            value={axnuiContentError[errorCode] || ""}
            disabled={isDisabled}
            isRequired={true}
            afterLabelTooltipText={""}
            afterLabelIcon={isDisabled ? null : faUndo}
            afterLabelIconOnClick={handleReset}
            rightAlignedLabelElement={rightAlignedLabelElement}
        />
        {validationError}
    </>
}